import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const ViewDocuments = ({ selected, pendingRequests }) => {
  const [documents, setDocuments] = useState([]);

  useEffect(() => {
    let documentData = pendingRequests?.find((item) => item?._id === selected);
    setDocuments(documentData);
  }, []);

  const extractFileName = (url) => {
    const regex = /([^\/]+\.pdf)(?=\/|$)/i;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  return (
    <div className="view_documents">
      <div className="documents_list">
        {documents?.attachments?.map((document, index) => {
          return (
            <div>
              <Link to={document?.url}>File {index + 1}</Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ViewDocuments;
